import React, { useState, useRef } from "react";
import axios from "axios";
import "../styles/PostBlog.css";

const PostBlog = () => {
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    author: "",
    image: "",
    tags: "",
    category: "",
  });

  const [message, setMessage] = useState("");
  const contentRef = useRef(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Add markdown-style link to selected text
  const addLink = () => {
    const textarea = contentRef.current;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const selectedText = formData.content.slice(start, end);

    if (!selectedText) {
      alert("Select text to turn into a link!");
      return;
    }

    const url = prompt("Enter URL for the link:", "https://");
    if (!url) return;

    const newText =
      formData.content.slice(0, start) +
      `[${selectedText}](${url})` +
      formData.content.slice(end);

    setFormData({ ...formData, content: newText });
  };

  const handleSubmit = async (e) => {

  e.preventDefault();
  try {
    const payload = {
      ...formData,
      tags: formData.tags.split(",").map((tag) => tag.trim())
    };
    const res = await axios.post("https://anyworq.com/api/blogs", payload);
    setMessage("✅ Blog posted successfully!");
    setFormData({
      title: "",
      content: "",
      author: "",
      image: "",
      tags: "",
      category: ""
    });
    console.log("New Blog Created:", res.data);
    console.log("Blog Slug:", res.data.slug); // You can see the generated slug
  } catch (err) {
    console.error(err);
    setMessage("❌ Failed to post blog. Try again!");
  }
};

  return (
    <div className="post-blog">
      <h2>Post a New Blog</h2>
      <form onSubmit={handleSubmit} className="blog-form">
        <input
          type="text"
          name="title"
          placeholder="Blog Title"
          value={formData.title}
          onChange={handleChange}
          required
        />
        <div style={{ position: "relative" }}>
          <textarea
            ref={contentRef}
            name="content"
            placeholder="Blog Content (use 'Add Link' to insert links)"
            value={formData.content}
            onChange={handleChange}
            required
          ></textarea>
          <button
            type="button"
            onClick={addLink}
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
              padding: "6px 10px",
              fontSize: "0.85rem",
              cursor: "pointer",
              borderRadius: "5px",
              border: "none",
              background: "#0a7d7d",
              color: "#fff",
            }}
          >
            Add Link
          </button>
        </div>

        <input
          type="text"
          name="author"
          placeholder="Author Name"
          value={formData.author}
          onChange={handleChange}
        />
        <input
          type="text"
          name="image"
          placeholder="Image URL"
          value={formData.image}
          onChange={handleChange}
        />
        <input
          type="text"
          name="tags"
          placeholder="Tags (comma separated)"
          value={formData.tags}
          onChange={handleChange}
        />
        <input
          type="text"
          name="category"
          placeholder="Category"
          value={formData.category}
          onChange={handleChange}
        />

        <button type="submit">Post Blog</button>
      </form>

      {message && <p className="status">{message}</p>}
    </div>
  );
};

export default PostBlog;
